module.exports = __webpack_public_path__ + "3628f350a4d034bdb6b91bfbc343b9a6.svg";